import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const bilsoftReq = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

async function loginBilsoft(taxNumber, databaseId, period, username, password, apiUsername, apiPassword) {
    return await bilsoftReq.post(`${BASE_URL}/bilsoft/girisYap`, {
        vergiNumarasi: taxNumber,
        veritabaniAd: databaseId,
        donemYil: period,
        kullaniciAdi: username,
        kullaniciSifre: password,
        apiKullaniciAdi: apiUsername,
        apiKullaniciSifre: apiPassword,
        subeAd: null
    });
}

async function loginBilsoftForDatabaseId(taxNumber, username, password) {
    return await bilsoftReq.post(`${BASE_URL}/bilsoft/girisYapDonemGetir`, {
        vergiNumarasi: taxNumber,
        kullaniciAdi: username,
        kullaniciSifre: password
    });
}

export { loginBilsoft, loginBilsoftForDatabaseId };
